import { createAction, props } from '@ngrx/store';
import { MessageEntity } from './message.models';
import { MessageDTO } from '@care-portals/api-interfaces';

export const loadMessages = createAction(
  '[Inbox] Load Messages',
  props<{ filters: any }>()
);

export const loadMessagesSuccess = createAction(
  '[Inbox] Load Messages Success',
  props<{ messages: MessageEntity[] }>()
);

export const loadMessagesFailure = createAction(
  '[Inbox] Load Messages Failure',
  props<{ error: any }>()
);

export const sendMessage = createAction(
  '[Inbox] Send Message',
  props<{ message: MessageDTO, updateWatchList: boolean }>()
);

export const sendMessageSuccess = createAction(
  '[Inbox] Send Message Success',
  props<{ message: MessageEntity, updateWatchList: boolean }>()
);

export const sendMessageFailure = createAction(
  '[Inbox] Send Message Failure',
  props<{ error: any }>()
);
